export default "__VITE_ASSET__b2c666c7__"